<template>
  <form @submit.prevent="getAuth">
    <p class="mb-3">
      Digite o código que enviamos para o WhatsApp: <span class="text-nowrap">{{ telefone }}</span> <a href="javascript:" class="text-primary ml-1" @click="$emit('voltar')">(Alterar)</a>.
    </p>
    <div class="form-group mb-3">
      <the-mask id="validar_cod_pin" :mask="['#-#-#-#-#-#']" class="form-control" type="tel"
                autocomplete="one-time-code" placeholder="#-#-#-#-#-#" v-model="pin" required minlength="6" @keyup.enter.native="getAuth()" :disabled="load"/>
    </div>
    <div class="alert-error small mt-2" v-if="error">
      <div v-if="error">{{ error }}</div>
    </div>
    <div class="text-center small mb-4" style="min-height: 18px">
      <div v-if="segundos <= 0"><a href="javascript:" class="text-primary" @click="reenviar()">Reenviar código</a></div>
      <div v-else>Reenviar em <b style="font-variant-numeric: tabular-nums">{{ segundos }}</b> segundos.</div>
    </div>
    <button class="btn btn-primary btn-block py-2" :disabled="load">{{load ? 'Aguarde' : 'Continuar'}}</button>
    <div class="text-center mt-4 mb-2">
      <a href="https://lecard.tawk.help/article/como-visualizar-o-codigo-2-fatores" target="_blank" class="text-primary text-decoration-none">Preciso de Ajuda</a>
    </div>
  </form>
</template>

<script>
export default {
  name: "Auth2",
  props: ['telefone', 'error', 'load'],

  data() {
    return {
      segundos: 60,
      interval: null,
      pin: ''
    }
  },

  methods: {
    getAuth() {
      if (!this.pin || this.pin.length < 6) {
        this.$swal('Por favor informe um código com 6 dígitos').then(() => {
          this.$helpers.focusElement('validar_cod_pin');
        });

        return;
      }

      this.$emit('auth', this.pin);
    },

    reenviar() {
      if (this.load) {
        return;
      }

      this.$emit('auth');
      this.segundos = 60;
      this.countDown();
    },

    countDown() {
      clearInterval(this.interval);
      this.$helpers.focusElement('validar_cod_pin');

      this.interval = setInterval(() => {
        this.segundos = this.segundos - 1;
        localStorage.setItem('segundos', this.segundos);

        if (this.segundos < 0) {
          localStorage.removeItem('segundos');
          clearInterval(this.interval);
        }
      }, 1000);
    },
  },

  mounted() {
    this.segundos = localStorage.getItem('segundos') || 60;
    this.countDown();
  }
}
</script>

<style scoped>

</style>